<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="orderCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createByName="{ row }">
        <div>
          <span>{{ row.createByName }}</span>
          <br />
          <span>{{ row.createTime }}</span>
        </div>
      </template>
      <template v-slot:modifyByName="{ row }">
        <div>
          <span>{{ row.modifyByName }}</span>
          <br />
          <span>{{ row.modifyTime }}</span>
        </div>
      </template>
      <template v-slot:orderStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'N'
              ? 'success'
              : row.orderStatus === 'Y'
              ? 'light'
              : 'warning'
          "
        >
          {{ row.orderStatusName }}
        </el-tag>
      </template>
      <template v-slot:waybill="{row}">
        <div>
          <span>{{row.wayBillNo?row.wayBillNo:'--'}}</span>
        </div>
      </template>
      <template v-slot:orderso="{row}">
        <div>
          <span>{{row.orderSoNo?row.orderSoNo:'--'}}</span>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  code: row.orderCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            v-allow="'actModify'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  code: row.orderCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            v-allow="'actDel'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.orderCode)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="提交调度"
            v-allow="'actDispatch'"
            placement="top"
          >
            <i
              class="el-icon-check tool-btn"
              @click="singleSumit(row.orderCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      title="更新必填字段"
      :show-close="true"
      :visible.sync="updateFieldsDialogVisible"
      v-el-dialog-drag
      width="400px"
      :close-on-click-modal="false"
      @close="closeAdvqueryDialog"
    >
      <el-form
        ref="formData"
        :model="formData"
        label-position="left"
        label-width="80px"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="运输模式" prop="transportMode" size="small" style="">
              <dict-select
                clearable
                v-model="formData.transportMode"
                placeholder="请选择运输模式"
                default
                filterable
                :body="selectTransportMode"
              >
              </dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">取消</el-button>

        <el-button size="small" type="primary" @click="saveFields()"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import validate from '@/libs/util.validate'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      previewDialogOptions: {
        viewVisible: false,
        code: '',
      },
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      selectList: [],
      fullScreenLoading: false,
      updateFieldsDialogVisible: false,
      orderDetailDialogOptions: {
        no: '',
        visible: false,
      },
      selectTransportMode: { type: 'transportMode' },

      formData: {
        transportMode: '',
      },
      rules: {
        transportMode: [
          { required: true, message: '请选择运输模式', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    del(code) {
      this.$confirm('确认要取消该条订单吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api.bizOrderInfoDelApi({ orderCode: code }).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    singleSumit(code) {
      this.$confirm('确认要提交调度吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.selectList = [code]
        this.submit(this.selectList)
      })
    },
    batchSumit() {
      this.$confirm('确认要批量提交调度吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        // 缓存的选中数据，非当前页数据
        let reserveRecords = this.$refs.table.getCheckboxReserveRecords()
        // 当前页选中的数据
        let selectRecords = this.$refs.table.getCheckboxRecords()
        let totCount = reserveRecords.length + selectRecords.length
        if (totCount === 0) {
          this.$message.warning('请选择需要提交调度的订单')
          return false
        }
        this.selectList = []
        // 将缓存中的选中数据，加入已选中数据列表
        if (reserveRecords.length > 0) {
          reserveRecords.forEach((row) => {
            this.selectList.push(row.orderCode)
          })
        }
        // 将当前页选中数据，加入已选中数据列表
        if (selectRecords.length > 0) {
          selectRecords.forEach((row) => {
            this.selectList.push(row.orderCode)
          })
        }
        if (totCount > 20) {
          this.$message.warning('每次批量提交调度的订单数量，不能超过20张')
          return false
        }
        this.submit(this.selectList)
      })
    },
    openEditPage({ pageType, code }) {
      this.$router.push({
        name: 'carriage-order-detail',
        params: { orderCode: code, pageType },
      })
    },
    updateFields() {
      const data = this.getTableCheckedData()
      if (data === null || data === [] || data === undefined) {
        return
      }
      this.updateFieldsDialogVisible = true
    },
    getTableCheckedData() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (data === null || data === [] || data.length === 0) {
        this.$message({
          message: '请选择您要操作的数据！',
          type: 'warning',
        })
        return
      }
      this.selectList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (data.length > 0) {
        data.forEach((row) => {
          this.selectList.push(row.orderCode)
        })
      }
      return this.selectList
    },
    async saveFields() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) {
        this.$message.error('有必输字段未填写，请检查')
        return
      }
      this.fullScreenLoading = true
      this.$api
        .bizOrderInfoUpdateFieldsApi({
          orderCodeList: this.selectList,
          ...this.formData,
        })
        .then((res) => {
          this.fullScreenLoading = false
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          // 清除选中的记录
          this.$refs.table.clearCheckboxRow()
          this.$refs.table.clearCheckboxReserve()
          this.updateFieldsDialogVisible = false
          this.$emit('reload')
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    closeAdvqueryDialog() {
      this.updateFieldsDialogVisible = false
      this.$nextTick(() => {
        // 清空表单
        this.$refs.formData.resetFields()
      })
    },
    submit(data) {
      this.fullScreenLoading = true
      this.$api
        .bizOrderInfoUnconfirmedSubmitApi({ listCode: data })
        .then((res) => {
          this.fullScreenLoading = false
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          // 清除选中的记录
          this.$refs.table.clearCheckboxRow()
          this.$refs.table.clearCheckboxReserve()
          this.$emit('reload')
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-col {
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>
